import { observable, action, runInAction } from 'mobx';

import Service from '@service/index';
import { toggleValue } from '@store/index';

const moVip = observable({
  commentList: <any[]>[],
  isApply: false,
  remark: '',
  isAlert: false,
  alertText: '',
  text1: '',
  text2: '',
  text3: '',
});

const vipInit = action(() => {
  console.log('vip init');
  toggleValue('isLoading', false);
});

const changeApply = action((value: boolean) => {
  moVip.isApply = value;
});

const changeRemark = action((value: string) => {
  moVip.remark = value;
});

const changeText = action((text1: string, text2: string, text3: string) => {
  moVip.text1 = text1;
  moVip.text2 = text2;
  moVip.text3 = text3;
});

const toApplication = action(async (remark: string) => {
  const params: any = { remark };
  const res: any = await Service.application(params);
  console.log(res);
  if (res.code !== 0) {
    moVip.isAlert = false;
    moVip.alertText = '网络错误，请重新提交!';
  }
  runInAction(() => {
    moVip.isAlert = true;
    moVip.alertText = '提交成功!';
    setTimeout(() => { moVip.isAlert = false; }, 2000);
  });
});

export default moVip;
export {
  vipInit, changeApply, toApplication, changeRemark, changeText,
};
